// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltip-content":"panel-email-template__tooltip-content___3XI4g","tooltipContent":"panel-email-template__tooltip-content___3XI4g"};
    if(module.hot) {
      // 1769468787430
      var cssReload = require("../../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  